import React from 'react';
import { twMerge } from 'tailwind-merge';
import clsx from 'clsx';

const Badge = ({
  children,
  variant = 'default',
  color,
  size = 'md',
  className,
  dot = false,
  removable = false,
  onRemove,
  ...props
}) => {
  const variants = {
    default: 'bg-secondary-100 text-secondary-800',
    primary: 'bg-primary-100 text-primary-800',
    success: 'bg-success-100 text-success-800',
    warning: 'bg-warning-100 text-warning-800',
    danger: 'bg-danger-100 text-danger-800',
    info: 'bg-primary-100 text-primary-800',
    secondary: 'bg-secondary-100 text-secondary-700',
    outline: 'bg-white text-secondary-700 border border-secondary-300',
    'primary-solid': 'bg-primary-600 text-white',
    'success-solid': 'bg-success-600 text-white',
    'warning-solid': 'bg-warning-600 text-white',
    'danger-solid': 'bg-danger-600 text-white',
  };

  const colorMap = {
    green: 'bg-success-100 text-success-800',
    yellow: 'bg-warning-100 text-warning-800',
    red: 'bg-danger-100 text-danger-800',
    blue: 'bg-primary-100 text-primary-800',
    gray: 'bg-secondary-100 text-secondary-700',
    purple: 'bg-purple-100 text-purple-800',
    orange: 'bg-warning-100 text-warning-800',
  };

  const resolvedVariant = color
    ? (colorMap[color] || variants.default)
    : (variants[variant] || variants.default);

  const sizes = {
    xs: 'px-1.5 py-0.5 text-xs',
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-0.5 text-sm',
    lg: 'px-3 py-1 text-sm',
  };

  const dotSizes = {
    xs: 'h-1.5 w-1.5',
    sm: 'h-2 w-2',
    md: 'h-2 w-2',
    lg: 'h-2.5 w-2.5',
  };

  return (
    <span
      className={twMerge(
        clsx(
          'inline-flex items-center font-medium rounded-full',
          resolvedVariant,
          sizes[size],
          className
        )
      )}
      {...props}
    >
      {dot && (
        <span
          className={clsx(
            'rounded-full bg-current opacity-40',
            dotSizes[size],
            children && 'mr-1.5'
          )}
        />
      )}
      {children}
      {removable && (
        <button
          onClick={onRemove}
          className="ml-1 -mr-0.5 inline-flex items-center justify-center rounded-full p-0.5 hover:bg-black/10 focus:outline-none"
          aria-label="Remove"
        >
          <svg
            className={clsx(
              'fill-current',
              size === 'xs' ? 'h-2.5 w-2.5' : 'h-3 w-3'
            )}
            viewBox="0 0 20 20"
          >
            <path
              fillRule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      )}
    </span>
  );
};

export default Badge;
